import { isApiError, makeApiError, ProblemDetailsSchema, StatusSchema } from '@/js/libs/api';
import isCancelError from './isCancelError';
// FIXME: this return type is a lie in case of error out of makeRequest catch
export const parseError = (e, apiName) => {
    if (isCancelError(e))
        return undefined;
    let error;
    if (isApiError(e, ProblemDetailsSchema)) {
        error = e;
    }
    else if (isApiError(e, StatusSchema)) {
        error = {
            ...e,
            response: {
                ...e.response,
                data: {
                    message: e.message,
                },
                status: e.response?.status,
            },
        };
    }
    else {
        // @ts-expect-error try to touch unknown error
        const message = e ? e.message || String(e) : 'Unknown error';
        error = makeApiError(ProblemDetailsSchema, {
            response: undefined,
            message,
            status: -1,
            request: {
                response: '',
            },
        });
    }
    if (error.response?.data?.message) {
        error.message = error.response.data.message;
    }
    // @ts-expect-error it will be useful while debugging
    error.apiName = apiName;
    return error;
};
